import React from "react";
import { Field } from "redux-form";
import IndexedFormRow from "../IndexedFormRow";
import { Translate } from "react-localize-redux";
import CollapseContainer from "../../CollapseContainer/CollapseContainer";
import { renderField } from "../../../utils/formUtils";
import PrivacyRow from "../PrivacyRow/PrivacyRow";

const PhoneNumberFormPanel = () => (
  <CollapseContainer
    title={<Translate id="PhoneNumbers" />}
    startCollapsed={false}
  >
    <IndexedFormRow
      modelArrayName="phone_numbers"
      privacyRow={<PrivacyRow rowOffset={10} />}
      dataComponent={member => (
        <Field
          name={`${member}.number`}
          type="text"
          hideLabel={true}
          component={renderField}
          label="number"
        />
      )}
    />
  </CollapseContainer>
);

export default PhoneNumberFormPanel;



// WEBPACK FOOTER //
// ./src/components/forms/PhoneNumberFormPanel/PhoneNumberFormPanel.jsx